import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TargetListLineResolved} from "../target-list.service";

@Component({
  selector: 'asax-header-target-list-info',
  templateUrl: './target-list-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TargetListInfoComponent {
  @Input() targetListLinesResolved: TargetListLineResolved[];

}
